import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import base from './base';
import palette from './palette';

const input = {
  MuiFormControl: {
    styleOverrides: {
      marginNormal: {
        marginTop: 0,
        marginBottom: '20px',
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        background: palette.common.black,
        borderTopLeftRadius: base.shape.borderRadius,
        borderTopRightRadius: base.shape.borderRadius,
        color: palette.common.white,
        fontSize: '14px',
        lineHeight: 1.2,
        padding: '1px 10px 3px',
        transform: 'none',
        zIndex: 0,
        '&.Mui-focused': {
          color: palette.common.white,
        },
        '&.Mui-required': {
          background: palette.red[600],
          color: palette.common.white,
        },
        '&.Mui-disabled': {
          background: palette.grey[600],
          color: palette.common.white,
        },
        '&.MuiFormLabel-filled:not(.Mui-focused, .Mui-disabled)': {
          background: palette.grey[800],
        },
        '&.MuiFormLabel-filled.Mui-error': {
          background: palette.common.black,
          color: palette.common.white,
          '&.Mui-required': {
            background: palette.red[600],
          },
        },
      },
      asterisk: {
        display: 'none',
      },
    },
  },
  MuiInput: {
    styleOverrides: {
      root: {
        backgroundColor: palette.common.white,
        border: `1px solid ${palette.grey[600]}`,
        borderRadius: base.shape.borderRadius,
        'label + &': {
          marginTop: '18px',
        },
        '&:before, &:after': { display: 'none' },
        '&.Mui-focused': {
          borderColor: palette.common.black,
        },
        '.Mui-required:not(.MuiFormLabel-filled) + &:not(.Mui-focused, .Mui-disabled)': {
          borderColor: palette.red[600],
        },
        '.MuiFormLabel-filled + &:not(.Mui-focused, .Mui-error, .Mui-disabled)': {
          background: palette.grey[100],
          borderColor: palette.grey[600],
        },
        '&.Mui-error:not(.Mui-focused)': {
          background: palette.red[100],
          borderColor: palette.red[600],
        },
        '&.Mui-disabled': {
          backgroundColor: palette.grey[100],
          borderColor: palette.grey[150],
          '& .Mui-disabled': {
            WebkitTextFillColor: palette.grey[800],
          },
        },
      },
      adornedEnd: {
        paddingRight: '7px',
      },
      adornedStart: {
        paddingLeft: '3px',
      },
      input: {
        boxSizing: 'border-box',
        fontSize: '0.875rem',
        lineHeight: '1.143em',
        height: 38,
      },
      inputSizeSmall: {
        padding: '7px 10px',
        height: 30,
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      IconComponent: KeyboardArrowDownIcon,
    },
    styleOverrides: {
      select: {
        paddingRight: '28px !important',
      },
      icon: {
        fontSize: 18,
        right: '8px',
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      size: 'small',
      margin: 'normal',
      variant: 'standard',
      slotProps: {
        inputLabel: { shrink: true },
      },
    },
  },
};
export default input;
